import React from 'react'

import Header from '../../../components/header'
import SearchCard from '../../../components/search-card'
import DoctorCard from '../../../components/doctor-card'
import SearchDoctors from '../../../components/search-doctors'

import * as S from './styles'

import IProps from './props'

const Result = ({
  filter,
  filterVisibility,
  toggleFilterVisibility,
  handleSearch,
  results,
  relatedResults,
  specialties,
  states,
  loadCities,
}: IProps) => (
  <S.Container>
    <Header title="Resultado da busca" />
    <SearchCard
      filter={filter}
      toggleFilterVisibility={toggleFilterVisibility}
      onSearch={handleSearch}
    />
    {filterVisibility && (
      <S.FilterContainer>
        <SearchDoctors
          onSearch={handleSearch}
          specialtyList={specialties}
          stateList={states}
          loadCities={loadCities}
        />
      </S.FilterContainer>
    )}
    <S.Section>
      <S.SectionTitle>
        {results.length < 10 ? `0${results.length}` : results.length}
        {' '}
        Resultados
      </S.SectionTitle>
      <S.SectionContent>
        <>
          {results.map((doctor: any) => (
            <DoctorCard
              key={`result-${doctor.id}`}
              name={doctor.name}
              location={doctor.location}
              linkChat={doctor.linkChat}
              linkProfile={doctor.linkProfile}
              detailTitle="Cidade(s) que deseja trabalhar"
            />
          ))}
        </>
      </S.SectionContent>
    </S.Section>
    {relatedResults.length > 0 && (
      <S.Section>
        <S.SectionTitle>
          Médicos próximos de
          {' '}
          {filter.locations
            .map((location) => location.cities)
            .flat()
            .join(', ')}
        </S.SectionTitle>
        <S.SectionContent>
          <>
            {relatedResults.map((doctor: any) => (
              <DoctorCard
                key={`related-result-${doctor.id}`}
                name={doctor.name}
                location={doctor.location}
                linkChat={doctor.linkChat}
                linkProfile={doctor.linkProfile}
                detailTitle="Cidade(s) que deseja trabalhar"
              />
            ))}
          </>
        </S.SectionContent>
      </S.Section>
    )}
  </S.Container>
)

export default Result
